enum TaxType {
    Auto = 0,
    FlatPercentage = 1,
    TaxExempt = 2,
    Custom = 3,
}

export { TaxType };
